import { useQuery } from '@tanstack/react-query';

import { GetPromoWarningsQuery, getPromoWarnings } from '~/services/PromoService';

export const promoWarningsQueryKeys = {
  all: ['promo-warnings'] as const,
  detail: (codeName: string, brand: GetPromoWarningsQuery['brand']) =>
    [...promoWarningsQueryKeys.all, 'detail', codeName, brand] as const,
};

export function useGetPromoWarnings({ codeName, brand }: { codeName: string; brand: GetPromoWarningsQuery['brand'] }) {
  return useQuery({
    queryKey: promoWarningsQueryKeys.detail(codeName, brand),
    queryFn: ({ signal }) => getPromoWarnings({ codeNames: [codeName], brand }, { signal }),
    enabled: Boolean(codeName && brand),
    refetchOnWindowFocus: false,
    select: (response) => response.result,
  });
}
